import axios from '@/utils/requset'
import { responseHandler } from '@/utils/http'

export function getQuestionList(parameter) {
  return axios({
    url: '/client/exam/getAllQuestion',
    method: 'post',
    data: parameter
  })
}

export function getQuestionNumList(parameter) {
  return axios({
    url: '/client/exam/getQuestionNumList',
    method: 'post',
    data: parameter
  })
}
export function getAllQuestion(parameter) {
  return axios({
    url: '/client/exam/getAllQuestion',
    method: 'post',
    data: parameter
  })
}
export function getScore(parameter) {
  return axios({
    url: '/client/exam/getScore',
    method: 'post',
    data: parameter
  })
}


export function getQuestionNumSortList(parameter) {
  return axios({
    url: '/client/exam/getQuestionNumSortList',
    method: 'post',
    data: parameter
  })
}

export function examStart(parameter) {
  return axios({
    url: '/client/exam/examStart',
    method: 'post',
    data: parameter
  })
}
export function getStartDate(parameter) {
  return axios({
    url: '/client/exam/getStartDate',
    method: 'post',
    data: parameter
  })
}

export function saveAnswer(parameter) {
  return axios({
    url: '/client/exam/saveAnswer',
    method: 'post',
    data: parameter
  })
}

export function completeTestPaper(parameter) {
  return axios({
    url: '/client/exam/completeTestPaper',
    method: 'post',
    data: parameter
  })
}

export function questionList({ params,page }) {
  console.log({ params,page })
  return axios({
    url: '/client/exam/getQuestions',
    method: 'post',
    params: {
      pageNo: page.pageNo,
      pageSize: page.pageSize
    },
    data: { ...params }
  })
}

export function questionRandomList({ params,page }) {
  console.log({ params,page })
  return axios({
    url: '/client/exam/getRandomQuestions',
    method: 'post',
    params: {
      pageNo: page.pageNo,
      pageSize: page.pageSize
    },
    data: { ...params }
  })
}

export function getPreviousQuestions({ params,page }) {
  console.log({ params,page })
  return axios({
    url: '/client/exam/getPreviousQuestions',
    method: 'post',
    params: {
      pageNo: page.pageNo,
      pageSize: page.pageSize
    },
    data: { ...params }
  })
}

export function examRestart(parameter) {
  return axios({
    url: '/client/exam/examRestart',
    method: 'post',
    data: parameter
  })
}